import { mapStores } from 'pinia'
import { useApiStore } from '@/stores/apiStore'

export default {
  mounted() {
    this.getCSRFtoken();
  },
  data () {
    return {
      userCSRFToken: '',
    }
  },
  computed: {
    // note we are not passing an array, just one store after the other
    // each store will be accessible as its id + 'Store'
    ...mapStores(useApiStore),
    requestHeaders() {
      return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.userCSRFToken,
      }
    },
  },
  methods: {
    async getCSRFtoken() {
      this.userCSRFToken = await this.apiStore.getCrsf;
    },
  },
}
